export const TagCategories = (listings, query) => {
  tagListings(listings, query)
}

function tagListings(listings, query) {
  // GA4
  const relatedListingsData = listings.map((listing, index) => {
    return {
      item_name: listing.title,
      item_id: listing.id,
      item_brand: listing.artist.full_name,
      price: parseInt(listing.price.dollars),
      index: index,
      quantity: 1,
    }
  })
  dataLayer.push({
    event: "view_item_list",
    ecommerce: {
      item_list_id: "related_products",
      item_list_name: "Related products",
      items: relatedListingsData,
    },
  })
}
export default { TagCategories }
